import React, { useState, useContext, useEffect } from 'react';

import { listQuestionTemplates, listSectionTemplates, listFormTemplates, listOrgs, listUnitsByOrg, listDevicesByOrg, listAllDevices,
getFormTemplateBySlugValue, listFormTemplateActivities, listQuestionTemplateActivities, listQuestionTemplatesBySlugValue,
getFormTemplateByUId, fetchMedication, getFormTemplateByUIdV2, searchQuestions } from '../../graphql/queries'
import { createQuestionTemplate, createFormTemplate, updateFormTemplate, deleteFormTemplate, createUnitTestConfig, updateUnitTestConfig,
  updateQuestionTemplate, createQuestionTemplateActivity, createFormTemplateActivity, deleteFormTemplateActivity } from '../../graphql/mutations'
  import { csvJSON } from '../common/functions';


export {
    ListQuestionTemplatesQuery,
    listSectionTemplatesQuery,
    createQuestionTemplateMut,
    createFormTemplateMut,
    listFormTemplatesQuery,
    updateFormTemplateMut,
    deleteFormTemplateMut,
    listOrgsQuery,
    listUnitsByOrgQuery,
    createUnitTestConfigMut,
    updateUnitTestConfigMut,
    listDevicesByOrgQuery,
    listAllDevicesQuery,
    getFormTemplateBySlugValueQuery,
    updateQuestionTemplateMut,
    listFormTemplateActivitiesQuery,
    listQuestionTemplateActivitiesQuery,
    createQuestionTemplateActivityMut,
    createFormTemplateActivityMut,
    deleteFormTemplateActivityMut,
    listQuestionTemplatesBySlugValueQuery,
    getFormTemplateByUIdQuery,
    fetchMedicationQuery,
    fetchMyList,
    getFormTemplateByUIdQueryV2,
    searchQuestionsQuery
}


const searchQuestionsQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: searchQuestions,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        console.log(err)
        rej(err)
      })
    })
  }



const fetchMyList = async (props, variables) => {
  return await new Promise((resolve, reject) => {
      fetch(`https://${variables.bucket}.s3-${variables.region}.amazonaws.com/${variables.orgId}/local-storage/${variables.user}/${variables.fileName}.csv `,{
         headers: {
              "Accept": "text/csv",
              "cache-control": "no-cache",
              "cache": "no-store"
            }
      })
      .then(response => {
        if(response.status == 200){
          return response.text()
        }else{
          return null
        }
      })
      .then((data) => {
        if(data != null){
          let arr =  csvJSON(data)
          resolve(arr)
        }else{
          resolve([])
        }
      }).catch((err)=>{
        console.log(err)
        reject(err)
      })
    })
  }


const fetchMedicationQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: fetchMedication,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        console.log(err)
        rej(err)
      })
    })
  }

const listQuestionTemplatesBySlugValueQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listQuestionTemplatesBySlugValue,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }

const deleteFormTemplateActivityMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: deleteFormTemplateActivity,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          // console.log(err)
          rej(err)
      })
  })
}



const createQuestionTemplateActivityMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: createQuestionTemplateActivity,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          // console.log(err)
          rej(err)
      })
  })
}



const createFormTemplateActivityMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: createFormTemplateActivity,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          // console.log(err)
          rej(err)
      })
  })
}


const listFormTemplateActivitiesQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listFormTemplateActivities,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }

  const listQuestionTemplateActivitiesQuery = async (props, variables) => {
    return await new Promise((res, rej) => {
      props.client.query({
        query: listQuestionTemplateActivities,
        variables: variables,
        fetchPolicy:'network-only'
      }).then((data) => {
          res(data)
        }).catch((err) => {
          // console.log(err)
          rej(err)
        })
      })
    }
  

const updateQuestionTemplateMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: updateQuestionTemplate,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          // console.log(err)
          rej(err)
      })
  })
}


const getFormTemplateByUIdQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: getFormTemplateByUId,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }

  const getFormTemplateByUIdQueryV2 = async (props, variables) => {
    return await new Promise((res, rej) => {
      props.client.query({
        query: getFormTemplateByUIdV2,
        variables: variables,
        fetchPolicy:'network-only'
      }).then((data) => {
          res(data)
        }).catch((err) => {
          // console.log(err)
          rej(err)
        })
      })
    }

  const getFormTemplateBySlugValueQuery = async (props, variables) => {
    return await new Promise((res, rej) => {
      props.client.query({
        query: getFormTemplateBySlugValue,
        variables: variables,
        fetchPolicy:'network-only'
      }).then((data) => {
          res(data)
        }).catch((err) => {
          // console.log(err)
          rej(err)
        })
      })
    }
  



const listAllDevicesQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listAllDevices,
      variables: variables,
      fetchPolicy:'no-cache'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }


const listDevicesByOrgQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listDevicesByOrg,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }



const updateUnitTestConfigMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: updateUnitTestConfig,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          rej(err)
      })
  })
}


const createUnitTestConfigMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: createUnitTestConfig,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          rej(err)
      })
  })
}


const listUnitsByOrgQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listUnitsByOrg,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }



const listOrgsQuery = async (props, variables = {}) => {
  const allItems = [];
  let nextToken = variables.nextToken || null;
  const seenTokens = new Set();

  do {
    if (nextToken) {
      if (seenTokens.has(nextToken)) {
        break;
      }
      seenTokens.add(nextToken);
    }

    const data = await props.client.query({
      query: listOrgs,
      variables: {
        limit: variables.limit || 100,
        nextToken,
      },
      fetchPolicy: 'network-only',
    });

    const page = data.data && data.data.listOrgs;
    if (page && page.items) {
      allItems.push(...page.items.filter(Boolean));
    }
    nextToken =
      page && page.nextToken && page.nextToken !== 'null'
        ? page.nextToken
        : null;
  } while (nextToken);

  return {
    data: {
      listOrgs: {
        items: allItems,
        nextToken: null,
      },
    },
  };
};



const deleteFormTemplateMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: deleteFormTemplate,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          rej(err)
      })
  })
}

const updateFormTemplateMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: updateFormTemplate,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          rej(err)
      })
  })
}



const createFormTemplateMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: createFormTemplate,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          rej(err)
      })
  })
}


const createQuestionTemplateMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: createQuestionTemplate,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          rej(err)
      })
  })
}

const listFormTemplatesQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listFormTemplates,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }

const listSectionTemplatesQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listSectionTemplates,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }

const ListQuestionTemplatesQuery = async (props, variables) => {
  return await new Promise((res, rej) => {
    props.client.query({
      query: listQuestionTemplates,
      variables: variables,
      fetchPolicy:'network-only'
    }).then((data) => {
        res(data)
      }).catch((err) => {
        // console.log(err)
        rej(err)
      })
    })
  }


;